import { Constants } from '@examdojo/supabase';

export const QUESTION_STATUSES = Constants.public.Enums.question_status;

export type QuestionStatus = (typeof QUESTION_STATUSES)[number];

/**
 * Transforms a status name like "NEEDS_REVIEW" to "Needs Review"
 */
function transformStatusToLabel(status: string): string {
  return status
    .split('_')
    .map((word) => {
      // Handle common abbreviations and acronyms
      if (word === 'AI') {
        return 'AI';
      }
      if (word === 'V2') {
        return 'V2';
      }

      // Convert to title case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

// Auto-generate labels from status names
export const QUESTION_STATUS_TO_LABEL: Record<QuestionStatus, string> = Object.fromEntries(
  QUESTION_STATUSES.map((status) => [status, transformStatusToLabel(status)]),
) as Record<QuestionStatus, string>;
